import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const GET_BIDDERS: TypedDocumentNode<Data, Variables> = gql`
  query bidders($accountType: BidderAccountTypeEnum!) {
    bidders(accountType: $accountType) {
      nodes {
        code
        id
        name
        sidRequired
        validator
        ybSid
      }
    }
  }
`
